import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux'
import { Flex } from 'reflexbox';
import TableBody from '@material-ui/core/TableBody';
import { Snackbar } from '@material-ui/core'

import * as organisationsActions from '../../redux/organisations';
import * as commissionsActions from '../../redux/commissions';
import * as invoiceActions from '../../redux/invoices';
import { HeaderTitle, MainTable, Row, TableColumn } from '../../healtheraComponents';
import HealtheraFooter from '../HealtheraFooter/HealtheraFooter';
import PatientReportDownload from './PatientReportDownload';

const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export default function DocumentsList(props) {

  const dispatch = useDispatch()
  const {
    commissions: { commissionsReports, error: errorCommission } = {},
    organisations: { documents, message: messageOrganisation, sales } = {},
    invoices: {
      invoices, pdp_invoices: pdpInvoices,
      error: errorInvoices,
    } = {},
  } = useSelector(({commissions, organisations, order, invoices}) => ({commissions, organisations, order, invoices }))

  const [orgID, setOrgID] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (errorInvoices) return setMessage(errorInvoices);
    if (errorCommission) return setMessage(errorCommission);
    if (messageOrganisation) return setMessage(messageOrganisation);
    setMessage('');
  }, [errorInvoices, errorCommission, messageOrganisation])

  useEffect(() => {
    const organisationID = props.match.params.organisationID;
    setOrgID(organisationID);
    dispatch(commissionsActions.getCommissionsReports(organisationID));
    dispatch(invoiceActions.getDeliveryInvoices(organisationID));
    dispatch(invoiceActions.getPDPInvoices(organisationID));
    dispatch(organisationsActions.getPaymentReports(organisationID));
    dispatch(organisationsActions.getSalesReports(organisationID));
  }, [dispatch, props.match.params.organisationID]);

  const handleClick = (orgID) => {
    let url = ''
    orgID ? url = `${process.env.PUBLIC_URL}/contract/${orgID}` : url = 'https://www.healthera.co.uk/eula'
    const win = window.open(url, '_blank')
    win.focus()
  }

  const handleClose = () => {
    dispatch(invoiceActions.resetError());
    dispatch(commissionsActions.resetError());
    dispatch(organisationsActions.resetError());
  }

  const createLinkAndClick = (data) => {
    const url = data.downloadLink;
    const fileName = data.fileName || `${data.year}-${months[data.month]}-${data.organisation_name}.pdf`;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleDownloadCommissionsPDF = (report) => {
    dispatch(commissionsActions.getCommissionReportDownloadLink(report, (link) => createLinkAndClick({ ...link, ...report})));
  }

  const handleDownloadInvoicePDF = (invoice) => {
    const fileName = invoice.file.name;
    dispatch(invoiceActions.getDeliveryInvoiceDownloadLink(invoice, ({ downloadLink }) => createLinkAndClick({ fileName, downloadLink })))
  }

  const handleDownloadPaymentReport = async (fileName) => {
    dispatch(organisationsActions.getPaymentReportDownloadLink({ fileName, orgID }, ({ downloadLink }) => createLinkAndClick({ fileName, downloadLink })));
  };

  const handleDownloadSalesReport = async (fileName) => {
    dispatch(organisationsActions.getSalesReportDownloadLink({ fileName, orgID }, ({ downloadLink }) => createLinkAndClick({ fileName, downloadLink })));
  };

  return (
    <div>
      <Snackbar open={!!message}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={3000}
        message={message} />
      <PatientReportDownload />
      {invoices && invoices.length ?
        (<div><Flex p={2} align='center'>
          <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>OTC and Service Charge Invoices</HeaderTitle>
        </Flex>
        <MainTable marginbottom={`50px`} width={`70%`}>
          <TableBody>
            {invoices.sort((a, b) => `${a.year}${a.month}` > `${b.year}${b.month}` ? -1 : 1).map(invoice => {
              return (
                <Row key={invoice._id}>
                  <TableColumn fontSize={`20px`}>{invoice.file.name}</TableColumn>
                  <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={handleDownloadInvoicePDF.bind(null, invoice)}>Download</TableColumn>
                </Row>
              );
            })}
          </TableBody>
        </MainTable></div>)
        : ''
      }
      {pdpInvoices && pdpInvoices.length ?
        (<div><Flex p={2} align='center'>
          <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>Commission Invoices</HeaderTitle>
        </Flex>
          <MainTable marginbottom={`50px`} width={`70%`}>
            <TableBody>
              {pdpInvoices.sort((a, b) => `${a.year}${a.month}` > `${b.year}${b.month}` ? -1 : 1).map(invoice => {
                return (
                  <Row key={invoice._id}>
                    <TableColumn fontSize={`20px`}>{invoice.file.name}</TableColumn>
                    <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={handleDownloadInvoicePDF.bind(null, invoice)}>Download</TableColumn>
                  </Row>
                );
              })}
            </TableBody>
          </MainTable></div>)
        : ''
      }
      {documents?.results?.length ?
        (<div><Flex p={2} align='center'>
          <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>List of Transactions</HeaderTitle>
        </Flex>
          <MainTable marginbottom={`50px`} width={`70%`}>
            <TableBody>
              {documents.results.map(fileName => {
                return (
                  <Row key={fileName}>
                    <TableColumn fontSize={`20px`}>{fileName}</TableColumn>
                    <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={handleDownloadPaymentReport.bind(null, fileName)}>Download</TableColumn>
                  </Row>
                );
              })}
            </TableBody>
          </MainTable></div>)
        : ''
      }
      {sales?.result?.length ?
        (<div><Flex p={2} align='center'>
          <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>OTC Sales List</HeaderTitle>
        </Flex>
          <MainTable marginbottom={`50px`} width={`70%`}>
            <TableBody>
              {sales.result.map(fileName => {
                return (
                  <Row key={fileName}>
                    <TableColumn fontSize={`20px`}>{fileName}</TableColumn>
                    <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={handleDownloadSalesReport.bind(null, fileName)}>Download</TableColumn>
                  </Row>
                );
              })}
            </TableBody>
          </MainTable></div>)
        : ''
      }
      {commissionsReports && commissionsReports.length ?
        (<div><Flex p={2} align='center'>
          <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>Summary</HeaderTitle>
        </Flex>
        <MainTable marginbottom={`50px`} width={`70%`}>
          <TableBody>
            {commissionsReports.sort((a, b) => `${a.year}${a.month}` > `${b.year}${b.month}` ? -1 : 1).map(report => {
              return (
                <Row key={`${report.year}_${report.month}`}>
                  <TableColumn fontSize={`20px`}>{`${report.year}-${months[report.month]}-${report.organisation_name}.pdf`}</TableColumn>
                  <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={handleDownloadCommissionsPDF.bind(null, report)}>Download</TableColumn>
                </Row>
              );
            })}
          </TableBody>
        </MainTable></div>)
        : ''
      }
      <Flex p={2} align='center'>
        <HeaderTitle fontSize={`20px`} padding={`21px 15px 0 0`}>Legal Documents</HeaderTitle>
      </Flex>
      <MainTable marginbottom={`150px`} width={`40%`}>
        <TableBody>
          <Row>
            <TableColumn fontWeight={`bold`}>Terms & Conditions</TableColumn>
            <TableColumn fontWeight={`Semi Bold`} color={`#2f9d6d`} cursor={`pointer`} align='right' onClick={() => handleClick.bind()}>View</TableColumn>
          </Row>
        </TableBody>
      </MainTable>
      {orgID && <HealtheraFooter />}
    </div>
  );
}
